import { render } from "./SwitchSimple.vue?vue&type=template&id=a8e040c8&scoped=true"
import script from "./SwitchSimple.vue?vue&type=script&lang=js"
export * from "./SwitchSimple.vue?vue&type=script&lang=js"

import "./SwitchSimple.vue?vue&type=style&index=0&id=a8e040c8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8e040c8"]])

export default __exports__